import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiHeaders } from ".";
import { RestResponse } from "../model";

@Injectable()
export class CommonProvider {

  constructor(private http: HttpClient) { }
  
  identifyZip(zip: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(`/api/zip/${zip}`, ApiHeaders.getOptions());
  }
}